import { CalculateFestivalEnv } from '@/domain/impact-calculate-festival/entities/calculate-festival-env.entity';
import { selectCurrentProjectFestival } from '@/domain/project-festival/project-festival.selectors';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

type Params = {
  projectId: number;
};

type Result = {
  env: CalculateFestivalEnv;
};

export const runImpactCalculateFestivalEnvForProject = createAppAsyncThunk(
  'impactCalculateFestival/runImpactCalculateFestivalEnvForProject',
  async (
    params: Params,
    { extra: { impactCalculateFestivalGateway, snackbarGateway }, getState },
  ): Promise<Result> => {
    try {
      const currentProject = selectCurrentProjectFestival(getState());
      const modelVersion = currentProject?.models?.env || '';
      const calculateEnv =
        await impactCalculateFestivalGateway.runImpactCalculateFestivalEnvForProject(
          params.projectId,
          modelVersion,
        );
      return { env: calculateEnv };
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('GetImpactCalculate.Message.error'));
}
